import React, { useMemo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { cx } from 'class-variance-authority'
import type { Product } from '@skop-app/lib-domain/types'

import { matchKey } from '@/utils/matchKey.utils'

interface ChipsCellRendererProps extends ICellRendererParams<Product> {
  context: {
    [key: string]: any[]
  }
}

export function ChipsCellRenderer({
  data,
  colDef,
  context,
  node,
}: ChipsCellRendererProps) {
  const field = colDef?.field ?? ''
  const value = data?.[field] || node?.aggData?.[field]

  const chips = useMemo(() => {
    if (!value) return []

    const references = context?.[field] || []
    const values = Array.isArray(value) ? value : [value]

    return values.map(({ value }) => {
      const { label, review } = matchKey(value, references)
      const key = `${label}-${value}`
      const color = review ? 'bg-orange-100' : 'bg-neutral-50'

      return { key, label, color, review }
    })
  }, [value, field, context])

  if (chips.length === 0) return null

  return (
    <ul className="flex h-full">
      {chips.map(({ key, label, color, review }) => (
        <li key={key} className="flex flex-row items-center">
          <span
            className={cx(color, 'mr-2 rounded-md px-2 leading-normal')}
            aria-label={`${label}${review ? ' (en attente de validation)' : ''}`}
          >
            {label}
          </span>
        </li>
      ))}
    </ul>
  )
}
